"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _require = require('preact'),
    cloneElement = _require.cloneElement,
    Component = _require.Component,
    toChildArray = _require.toChildArray;

var classNames = require('classnames');

var transitionName = 'uppy-transition-slideDownUp';
var duration = 250;
/**
 * Vertical slide transition.
 *
 * This can take a _single_ child component, which _must_ accept a `className` prop.
 *
 * Currently this is specific to the `uppy-transition-slideDownUp` transition,
 * but it should be simple to extend this for any type of single-element
 * transition by setting the CSS name and duration as props.
 */

var Slide = /*#__PURE__*/function (_Component) {
  _inherits(Slide, _Component);

  var _super = _createSuper(Slide);

  function Slide(props) {
    var _this;

    _classCallCheck(this, Slide);

    _this = _super.call(this, props);
    _this.state = {
      cachedChildren: null,
      className: ''
    };
    return _this;
  } // TODO: refactor to stable lifecycle method
  // eslint-disable-next-line


  _createClass(Slide, [{
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps) {
      var _this2 = this;

      var cachedChildren = this.state.cachedChildren;
      var child = toChildArray(nextProps.children)[0];
      if (cachedChildren === child) return null;
      var patch = {
        cachedChildren: child
      }; // Enter transition

      if (child && !cachedChildren) {
        patch.className = "".concat(transitionName, "-enter");
        cancelAnimationFrame(this.animationFrame);
        clearTimeout(this.leaveTimeout);
        this.leaveTimeout = undefined;
        this.animationFrame = requestAnimationFrame(function () {
          // Force it to render before we add the active class
          // this.base.getBoundingClientRect()
          _this2.setState({
            className: "".concat(transitionName, "-enter ").concat(transitionName, "-enter-active")
          });

          _this2.enterTimeout = setTimeout(function () {
            _this2.setState({
              className: ''
            });
          }, duration);
        });
      } // Leave transition


      if (cachedChildren && !child && this.leaveTimeout === undefined) {
        patch.cachedChildren = cachedChildren;
        patch.className = "".concat(transitionName, "-leave");
        cancelAnimationFrame(this.animationFrame);
        clearTimeout(this.enterTimeout);
        this.enterTimeout = undefined;
        this.animationFrame = requestAnimationFrame(function () {
          _this2.setState({
            className: "".concat(transitionName, "-leave ").concat(transitionName, "-leave-active")
          });

          _this2.leaveTimeout = setTimeout(function () {
            _this2.setState({
              cachedChildren: null,
              className: ''
            });
          }, duration);
        });
      } // eslint-disable-next-line


      this.setState(patch);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          cachedChildren = _this$state.cachedChildren,
          className = _this$state.className;

      if (!cachedChildren) {
        return null;
      }

      return cloneElement(cachedChildren, {
        className: classNames(className, cachedChildren.props.className)
      });
    }
  }]);

  return Slide;
}(Component);

module.exports = Slide;